import { AccountsTable } from "@/admin/accounts/AccountsTable.tsx";
import { createLazyFileRoute } from "@tanstack/react-router";

export const Route = createLazyFileRoute("/admin/_menu/_dual/accounts")({
    component: AccountsTable,
});
